const faLayer = {
  prefix: 'fal',
  iconName: 'layer',
  icon: [
    640,
    640,
    [],
    'f672',
    [
      'M64 400C64 409.4 69.4 417.9 77.9 421.8L296.5 522.8C311.4 529.7 328.6 529.7 343.5 522.8L562.1 421.8C570.6 417.9 576 409.4 576 400C576 390.6 570.6 382.1 562.1 378.2L436.1 320L343.5 362.8C328.6 369.7 311.4 369.7 296.5 362.8L203.9 320L77.9 378.2C69.4 382.1 64 390.6 64 400z',
      'M296.5 117.2C311.4 110.3 328.6 110.3 343.5 117.2L562.1 218.2C570.6 222.1 576 230.6 576 240C576 249.4 570.6 257.9 562.1 261.8L343.5 362.8C328.6 369.7 311.4 369.7 296.5 362.8L77.9 261.8C69.4 257.8 64 249.3 64 240C64 230.7 69.4 222.1 77.9 218.2L296.5 117.2z',
    ],
  ],
};
export default faLayer;
